import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ASAP_MINIHUB } from "app/auth/baseAsapMiniHub";
import moment from "moment";
import constants from "@tracking/utils/constants";

const { DATE_FORMAT } = constants;

const parseGetFiliaisTransportadoras = (params) => {
  return {
    dataInicial: moment(params.dataInicial).format(DATE_FORMAT.API),
    dataFinal: moment(params.dataFinal).format(DATE_FORMAT.API),
    // statusColetaRoteiros: params.statusColetaRoteiros,
    // tipoRoteiros: params.tipoRoteiros,
  };
};

const parseGetRoteirosAlertas = (params) => {
  return {
    gruposCodigos: params.gruposCodigos,
    filiaisIds: params.filiaisIds,
    dataRoteiros: moment(params.dataRoteiros).format(DATE_FORMAT.API),
    statusColetaRoteiros: params.statusColetaRoteiros,
    tipoRoteiros: params.tipoRoteiros,
    nivelExperienciaMotorista: params.nivelExperienciaMotorista,
  };
};

const parseGetRoteirosCriticidade = (params: any) => {
  return {
    gruposCodigos: params.gruposCodigos,
    filiaisIds: params.filiaisIds,
    dataRoteiros: moment(params.dataRoteiros).format(DATE_FORMAT.API),
    tipoCriticidade: params.tipoCriticidade,
    statusColetaRoteiros: params.statusColetaRoteiros,
    tipoRoteiros: params.tipoRoteiros,
    nivelExperienciaMotorista: params.nivelExperienciaMotorista,
  };
};

export const getFiliaisTransportadoras = createAsyncThunk(
  "torreMiniHubApp/torreMiniHub/getFiliaisTransportadoras",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP_MINIHUB.get(
        "/dashboard/roteiros/MINIHUB/pedidos/gruposefiliais",
        {
          params: parseGetFiliaisTransportadoras(params),
        }
      );
    } catch (err: any) {
      // dispatch(
      //   openModalError({
      //     title: "Erro ao exibir filiais e transportadoras",
      //     text: "Verifique se os dados digitados estão corretos!",
      //     btnLabel: "Voltar",
      //   })
      // );
      console.error(err.response);
    }
    return response.data;
  }
);

export const getSafraDiaEvolucao = createAsyncThunk(
  "torreMiniHubApp/torreMiniHub/getSafraDiaEvolucao",
  async (params: object) => {
    console.log(params);
    let response;
    try {
      response = await API_ASAP_MINIHUB.get(
        "/dashboard/safra/dia/MINIHUB/evolucao",
        {
          params: parseGetRoteirosAlertas(params),
          paramsSerializer: {
            indexes: null,
          },
        }
      );
    } catch (err: any) {
      // dispatch(
      //   openModalError({
      //     title: "Erro ao buscar criticidades dos roteiros",
      //     text: "Verifique se os dados digitados estão corretos!",
      //     btnLabel: "Voltar",
      //   })
      // );
      console.error(err.response);
    }
    return response.data;
  }
);

export const getSafraPlanejada = createAsyncThunk(
  "torreMiniHubApp/torreMiniHub/getSafraPlanejada",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP_MINIHUB.get(
        "/dashboard/safra/dia/MINIHUB/planejado",
        {
          params: parseGetRoteirosAlertas(params),
          paramsSerializer: {
            indexes: null,
          },
        }
      );
    } catch (err: any) {
      // dispatch(
      //   openModalError({
      //     title: "Erro ao buscar criticidades dos roteiros",
      //     text: "Verifique se os dados digitados estão corretos!",
      //     btnLabel: "Voltar",
      //   })
      // );
      console.error(err.response);
    }
    return response.data;
  }
);

export const getRoteirosAlertas = createAsyncThunk(
  "torreMiniHubApp/torreMiniHub/getRoteirosAlertas",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP_MINIHUB.get(
        "/dashboard/roteiros/MINIHUB/alertas",
        {
          params: parseGetRoteirosAlertas(params),
          paramsSerializer: {
            indexes: null,
          },
        }
      );
    } catch (err: any) {
      // dispatch(
      //   openModalError({
      //     title: "Erro ao exibir filiais e transportadoras",
      //     text: "Verifique se os dados digitados estão corretos!",
      //     btnLabel: "Voltar",
      //   })
      // );
      console.error(err.response);
    }
    return response.data;
  }
);

export const getRoteirosCriticidade = createAsyncThunk(
  "torreMiniHubApp/torreMiniHub/getRoteirosCriticidade",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP_MINIHUB.get(
        "/dashboard/roteiros/MINIHUB/criticidades",
        {
          params: parseGetRoteirosCriticidade(params),
          paramsSerializer: {
            indexes: null,
          },
        }
      );
    } catch (err: any) {
      // dispatch(
      //   openModalError({
      //     title: "Erro ao buscar criticidades dos roteiros",
      //     text: "Verifique se os dados digitados estão corretos!",
      //     btnLabel: "Voltar",
      //   })
      // );
      console.error(err.response);
    }
    return response.data;
  }
);
